import ENDPOINTS from "../../../constants/apiEndPoints";
import { axiosInstance } from "../../axiosInstance";

export const handleGetAllEquipmentsService = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_EQUIPMENT);
  return response?.data?.data;
};
